import { z } from 'zod';

import { TmCreditCardType, TmCreditCardSelectionType, TmCreditCard } from '@/tscapi/model/account';
export const FormSchemaWrapper = (selectedCreditCard, showSemafoneInput, completeSemafoneResp, creditCardType) => {
    const FormSchema = z
        .object({
            cvvEnabled: z.boolean(),
            semacardnumber: z
                .string()
                .refine((value) => !selectedCreditCard || value.trim() !== '', {
                    message: 'Please enter a valid credit card number.',
                })
                .optional(),
            makedefault: z.union([z.literal(true), z.literal(false), z.literal('indeterminate')]),
            semaexpirynumber: z
                .string()
                .regex(/^(0[1-9]|1[0-2])\/\d{2}$/, { message: 'Please enter a valid expiration date.' }),
            semacvv: z.string(),
        })
        .superRefine((schema, ctx) => {
            const { semacvv, cvvEnabled, semacardnumber } = schema;
            if (cvvEnabled) {
                if (creditCardType == TmCreditCardType.Visa || creditCardType == TmCreditCardType.MasterCard) {
                    if (semacvv.length != 3) {
                        ctx.addIssue({
                            code: z.ZodIssueCode.custom,
                            message:
                                'We are unable to verify your credit card because of an invalid CVV number. Please try again.',
                        });
                    }
                }

                if (creditCardType == TmCreditCardType.Amex) {
                    if (semacvv.length < 4) {
                        ctx.addIssue({
                            code: z.ZodIssueCode.custom,
                            message:
                                'We are unable to verify your credit card because of an invalid CVV number. Please try again.',
                        });
                    }
                }
            }
            if (!showSemafoneInput) {
                if (semacardnumber.length < 15 || semacardnumber.indexOf('*') > -1) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: 'Please enter a valid credit card number.',
                    });
                }
            } else {
                if (!completeSemafoneResp) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: 'Please enter a valid credit card number.',
                    });
                }
            }
        });
    return z.intersection(schemaCond, FormSchema);
};

const cvvEnabledSchema = z.object({
    cvvEnabled: z.literal(true),
    semacvv: z
        .string()
        .min(3, 'We are unable to verify your credit card because of an invalid CVV number. Please try again.'),
});
const cvvDisabledSchema = z.object({
    cvvEnabled: z.literal(false),
});
// We mark union depends of is_company attribute
const schemaCond = z.discriminatedUnion('cvvEnabled', [cvvEnabledSchema, cvvDisabledSchema]);

// We intersection with default properties
//const ValidatorSchema = z.intersection(schemaCond, FormSchema);
